import { defineStore } from 'pinia';
import cleanDeep from 'clean-deep';
import type {
  AnchorLinksBarPropertyBlock,
  PageBreadcrumbs,
  PageContent,
  PageFormMetaData,
  PageMetadata,
  RegistrationNumberModalSettings,
} from '~/types/generated-types';

interface PageContentState {
  _pageContent: PageContent | null;
}

const initialState: () => PageContentState = () => {
  return {
    _pageContent: null,
  };
};

export const usePageContentStore = defineStore('pageContent', {
  state: initialState,
  getters: {
    isDefined: (state: PageContentState): boolean => state._pageContent !== null,
    pageTheme: (state: PageContentState): string => state._pageContent?.pageInstance?.pageTheme ?? '',
    route: (state: PageContentState): string => state._pageContent?.route ?? '',
    serviceMakes: (state: PageContentState): string[] => state._pageContent?.serviceMakes ?? [],
    locale: (state: PageContentState): string => state._pageContent?.pageInstance?.metadata?.locale ?? '',
    branchSalesPersonContactPageUrl: (state: PageContentState): string | undefined =>
      state._pageContent?.branchSalesPersonContactPageUrl ?? undefined,
    branchTechnicianPersonContactPageUrl: (state: PageContentState): string | undefined =>
      state._pageContent?.branchTechnicianPersonContactPageUrl ?? undefined,
    metadata: (state: PageContentState): PageMetadata | undefined => state._pageContent?.pageInstance?.metadata || undefined,
    formMetaData: (state: PageContentState): PageFormMetaData | undefined => state._pageContent?.pageInstance?.formMetaData || undefined,
    activeConfigurationGroupId: (state: PageContentState): string => state._pageContent?.activeConfigurationGroupId ?? '',
    breadcrumbs: (state: PageContentState): PageBreadcrumbs | undefined => state._pageContent?.pageInstance?.breadcrumbs ?? undefined,
    departmentName: (state: PageContentState): string | undefined => state._pageContent?.car?.department?.departmentName ?? undefined,
    anchorLinkData: (state: PageContentState): AnchorLinksBarPropertyBlock | undefined =>
      state._pageContent?.anchorLinksBarSettings ?? undefined,
    car: (state: PageContentState) => state._pageContent?.car ?? undefined,
    registrationNumberSettings: (state: PageContentState): RegistrationNumberModalSettings | undefined =>
      state._pageContent?.registrationNumberModalSettings ?? undefined,
    pageType: (state: PageContentState): string => state._pageContent?.type ?? '',
  },
  actions: {
    changePageContent(pageContent: PageContent): void {
      this._pageContent = cleanDeep(pageContent);
    },
  },
});
